import PendingFamiliesPage from '@/pages/PendingFamiliesPage/index';

export default {
    path: '/rodziny-nieprzypisane',
    component: PendingFamiliesPage,
    name: 'families-to-accept',
    meta: { requiresAuth: true },
    children: []
};
